import Dprotocol from "src/DigitalProtocolModule/pages/DprotocolLanding";
import DprotocolSections from 'src/DigitalProtocolModule/pages/DprotocolSections'
import SoaDetails from 'src/DigitalProtocolModule/pages/SoaDetails'
import DpAddActivitySoa from "src/DigitalProtocolModule/pages/DpAddActivitySoa";


function DPAppLayout(props) {
    const {pathName} = props
    let content: any;

    const renderContent = () => {
        switch (pathName) {
            case "/dprotocol":
                content = (<Dprotocol/>);
                break;
            case "/dprotocol/endpoints":
            case "/dprotocol/study-population":
            case "/dprotocol/arms-cohorts":
            case "/dprotocol/soa":
                content = (<DprotocolSections/>);
                break;
            case "/dprotocol/soa-details":
                content = (<SoaDetails/>);
                break;
            case "/dprotocol/soa-details/add-activity-soa":
                content = (<DpAddActivitySoa/>);
                break;
        }
        return content;

    }
    return (
        <>{renderContent()}</>
    )
}

export default DPAppLayout;